import { makeStyles } from "@material-ui/core";

export default makeStyles((theme) => ({
  wrapper: {
    display: "flex",
    height: "100%",
    backgroundColor: theme.palette.background.main,
    // padding: theme.spacing(0, 25),
  },
  mainContent: {
    margin: 0,
  },
  pageContentWrapper: {
    minHeight: "90%",
    margin: 0,
    padding: [theme.spacing(6, 26), "!important"],
    "&.opanMenu": {
      padding: [theme.spacing(6, 26, 6, 12), "!important"],
    },
    "&.fullWidth": {
      padding: "0 !important",
      margin: "0 !important",
      width: "100%",
      height: "100%",
    },
    "&.backgroundColorWhite": {
      backgroundColor: theme.palette.background.paper,
      height: "100%",
    },
    [theme.breakpoints.down("sm")]: {
      padding: [theme.spacing(0, 5)],
    },
    [theme.breakpoints.up("xl")]: {
      padding: [theme.spacing(0, 100), "!important"],
      "&.classOpanMenu": {
        padding: [theme.spacing(0, 100), "!important"],
      },
      "&.opanMenu": {
        padding: [theme.spacing(0, 100), "!important"],
      },
    },
    "&.paddingLayout": {
      padding: [theme.spacing(6, 26), "!important"],
      "&.opanMenu": {
        padding: [theme.spacing(6, 26, 6, 12), "!important"],
      },
    },
  },
  content: {
    flexGrow: 1,
    height: "100vh",
    overflow: "auto",
  },
}));
